import {GenderTypes} from '@/enums/GenderTypes.enum';

export function toSalutation(gender?: GenderTypes | null) {
    if (typeof gender === 'undefined' || gender === null) {
        return '';
    }
    return GenderTypes.Record[gender]?.salutation || '';
}
